import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-simplyblu-apply.component.scss';
var BusinessDetails = /** @class */ (function () {
    function BusinessDetails() {
        this.businessNature = '';
        this.businessTradeName = '';
        this.contactName = '';
        this.merchantEmail = '';
        this.telephoneNumber = '';
        this.simplyBluConsent = '';
        this.consent = '';
    }
    return BusinessDetails;
}());
var FormItemSimplybluApply = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemSimplybluApply, _super);
    function FormItemSimplybluApply(element) {
        return _super.call(this, element) || this;
    }
    FormItemSimplybluApply.prototype.init = function () {
        this.form = this.element.querySelector("form");
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displayMessage = this.form.querySelector(".form-container__message");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displaySuccessPc = this.form.querySelector(".form-container__success-pc");
            this.displayError = this.form.querySelector('.form-container__error');
            // display views info
            this.sucess_userName = this.element.querySelector('.form-container__success--firstname');
            this.sucess_refNumber = this.element.querySelector('.form-container__success--refNumber');
            this.sucess_pc_userEmailAddress = this.element.querySelector('.form-container__success-pc--emailAddress');
        }
        this.buttonBeforeWeBeginContinue = this.element.querySelector('.js-simplyblu-beforeWeBegin__button');
        this.buttonSubmit = this.element.querySelector('.js-simplyblu-apply__button');
    };
    FormItemSimplybluApply.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonBeforeWeBeginContinue) {
            this.buttonBeforeWeBeginContinue.addEventListener("click", function (event) {
                _this.showDisplayView("fields");
            });
        }
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener('click', function (event) {
                var _button = event.target;
                var _form = _button.closest('form');
                var formFields = _form.querySelectorAll('input, select');
                _this.validationService.validate(formFields);
                // this.simplybluLegalRequiremntsValidations();
                var valid = Array.from(_form.querySelectorAll('.form__group--error'));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.resetForm();
            _this.showDisplayView("");
        }, false);
    };
    FormItemSimplybluApply.prototype.submitForm = function (form) {
        var _this = this;
        // fields
        var userName = form.querySelector('.form-container__success--firstname');
        var refNumber = form.querySelector('.form-container__success--refNumber');
        var pc_userEmailAddress = form.querySelector('.form-container__success-pc--emailAddress');
        var businessDetails = new BusinessDetails();
        // Business Details
        var directorOwnerName = form.querySelector('input[name="business-od-name"]');
        var contactName = ((directorOwnerName) ? directorOwnerName.value : '');
        var directorOwnerSurame = form.querySelector('input[name="business-od-surname"]');
        var contactSurname = ((directorOwnerSurame) ? directorOwnerSurame.value : '');
        businessDetails.contactName = ((contactName !== '' && directorOwnerSurame !== '') ? contactName + ' ' + contactSurname : '');
        var businessTradeName = form.querySelector('input[name="business-trade-name"]');
        businessDetails.businessTradeName = ((businessTradeName) ? businessTradeName.value : '');
        var businessEmail = form.querySelector('input[name="business-email-address"]');
        businessDetails.merchantEmail = ((businessEmail) ? businessEmail.value : '');
        var businessNature = form.querySelector('input[name="business-goods-services"]');
        businessDetails.businessNature = ((businessNature) ? businessNature.value : '');
        var businessPhoneNumber = form.querySelector('input[name="phone-number"]');
        businessDetails.telephoneNumber = ((businessPhoneNumber) ? businessPhoneNumber.value : '');
        var simplyBluConsent = form.querySelector('input[name="simplyblu-consent"]');
        var simplyBluConsentTermsConditions = form.querySelector('input[name="simplyblu-consent-terms-and-conditions"]');
        var simplyBluConsentTermsConditions2 = form.querySelector('input[name="simplyblu-consent-terms-and-conditions2"]');
        var simplyBluConsentCheck = (simplyBluConsent) ? simplyBluConsent.checked : '';
        var simplyBluConsentTermsConditionsCheck = (simplyBluConsentTermsConditions) ? simplyBluConsentTermsConditions.checked : '';
        var simplyBluConsentTermsConditions2Check = (simplyBluConsentTermsConditions2) ? simplyBluConsentTermsConditions2.checked : '';
        if (simplyBluConsentCheck === true && simplyBluConsentTermsConditionsCheck === true && simplyBluConsentTermsConditions2Check === true) {
            businessDetails.simplyBluConsent = 'YES';
            businessDetails.consent = 'YES';
        }
        else {
            businessDetails.simplyBluConsent = 'NO';
            businessDetails.consent = 'NO';
        }
        var postData = { 'businessDetails': businessDetails };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + '/pbbsaleads/v1/simplyblu/quick-signup';
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            if (response) {
                if (response.status && response.data) {
                    if (response.status === 200 && response.data.referenceNumber) {
                        _this.analyticsService.dtmFormComplete('complete', '200');
                        _this.showDisplayView("success");
                        userName.innerHTML = contactName;
                        refNumber.innerHTML = response.data.referenceNumber;
                    }
                    else if (response.status === 409) {
                        _this.analyticsService.dtmFormComplete('complete', '409');
                        _this.showDisplayView("successPc");
                        pc_userEmailAddress.innerHTML = businessDetails.merchantEmail;
                    }
                    else {
                        _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                        _this.showDisplayView("error");
                    }
                }
                else if (response.response.status && response.response.data) {
                    if (response.response.status === 200 && response.response.data.referenceNumber) {
                        _this.analyticsService.dtmFormComplete('complete', '200');
                        _this.showDisplayView("success");
                        userName.innerHTML = contactName;
                        refNumber.innerHTML = response.response.data.referenceNumber;
                    }
                    else if (response.response.status === 409) {
                        _this.analyticsService.dtmFormComplete('complete', '409');
                        _this.showDisplayView("successPc");
                        pc_userEmailAddress.innerHTML = businessDetails.merchantEmail;
                    }
                    else {
                        _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                        _this.showDisplayView("error");
                    }
                }
                else {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                    _this.showDisplayView("error");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                _this.showDisplayView("error");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            _this.showDisplayView("error");
        });
    };
    FormItemSimplybluApply.prototype.resetForm = function () {
        this.sucess_userName.innerHTML = '';
        this.sucess_refNumber.innerHTML = '';
        this.sucess_pc_userEmailAddress.innerHTML = '';
    };
    FormItemSimplybluApply.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displayMessage.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displaySuccessPc.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "message":
                this.displayMessage.classList.remove("hidden");
                break;
            case "fields":
                this.displayFields.classList.remove("hidden");
                break;
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "successPc":
                this.displaySuccessPc.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayMessage.classList.remove("hidden");
                break;
        }
    };
    return FormItemSimplybluApply;
}(Base));
export { FormItemSimplybluApply };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-simplyblu-apply/form-item-simplyblu-apply.component.ts
// module id = 953
// module chunks = 0